import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {HorribleHeroesGameConfig} from "../HorribleHeroesGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TweenLite} from "gsap";

// #386, #418 -> scatter is implemented as overlay now.
export class HHScatterOverlayView extends BaseView {
    private _scatterOverlays: PIXI.spine.Spine[] = [];

    public playLandingAnimation(reelId: number, symId: number): void {
        const scatterOverlay: PIXI.spine.Spine = this._scatterOverlays[reelId];

        scatterOverlay.y = Helper.getSymbolPositions(reelId, symId)[1];
        this.resetSpineItem(scatterOverlay);

        scatterOverlay.state.setAnimation(0, "bonusLanding", false);
    }

    public playLoopStartAnimation(reelId: number, symId: number): void {
        const scatterOverlay: PIXI.spine.Spine = this._scatterOverlays[reelId],
            name: string = "bonusLoopStart",
            animTime: number = scatterOverlay.spineData.findAnimation(name).duration;

        scatterOverlay.y = Helper.getSymbolPositions(reelId, symId)[1];
        this.resetSpineItem(scatterOverlay);

        scatterOverlay.state.setAnimation(0, name, false);

        TweenLite.delayedCall(animTime, () => this.playLoopAnimation(scatterOverlay));
    }

    public playTriggerAnimation(reelId: number, symId: number): void {
        const scatterOverlay: PIXI.spine.Spine = this._scatterOverlays[reelId],
            name: string = "bonusTrigger",
            animTime: number = scatterOverlay.spineData.findAnimation(name).duration;

        scatterOverlay.y = Helper.getSymbolPositions(reelId, symId)[1];
        this.resetSpineItem(scatterOverlay);

        scatterOverlay.state.setAnimation(0, name, false);

        TweenLite.delayedCall(animTime, () => {
            // #375 -> because the state can change to "NORMAL" from "onReelSpinAnimationStopped" method in "HorribleHeroesTimelineReelsController.ts" file
            if (scatterOverlay.visible && scatterOverlay.state.getCurrent(0).animation.name === name) {
                this.playLoopStartAnimation(reelId, symId);
            }
        });
    }

    public stopScatterAnimations(): void {
        for (let i: number = 0; i < this._scatterOverlays.length; i++) {
            const scatterOverlay: PIXI.spine.Spine = this._scatterOverlays[i];

            scatterOverlay.visible = false;
            scatterOverlay.state.clearTracks();
        }
    }

    protected initAnimations(): void {
        super.initAnimations && super.initAnimations();

        StageManager.getLayer(HorribleHeroesGameConfig.instance.LAYERS.SCATTER_OVERLAY.name).addChild(this);

        let position: number[];

        for (let i: number = 0; i < HorribleHeroesGameConfig.instance.REELS_NUM; i++) {
            position = Helper.getSymbolPositions(i, 0); // passing symId as 0 since we are only interested in x position.
            let scatterOverlay: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("Sland"));
            scatterOverlay.visible = false;
            scatterOverlay.position.set(position[0], 0);
            this.addChild(scatterOverlay);

            this._scatterOverlays.push(scatterOverlay);
        }
    }

    private playLoopAnimation(scatterOverlay: PIXI.spine.Spine): void {
        if (scatterOverlay.visible && scatterOverlay.state.getCurrent(0).animation.name === "bonusLoopStart") {
            this.resetSpineItem(scatterOverlay);

            scatterOverlay.state.setAnimation(0, "bonusLoop", true);
        }
    }

    private resetSpineItem(scatterOverlay: PIXI.spine.Spine): void {
        if (!scatterOverlay.visible) {
            scatterOverlay.updateTransform();
            scatterOverlay.visible = true;
            scatterOverlay.alpha = 1;
        }
        scatterOverlay.state.clearTracks();
        scatterOverlay.skeleton.setToSetupPose();
        scatterOverlay.skeleton.setSlotsToSetupPose();
        scatterOverlay.state.setEmptyAnimation(0, 0);
    }
}